export const SUBSPLASH_AUTH_PROVIDER_ID =
  '19bc7532-7e56-440c-bd2e-171026dd5195';
export const SUBSPLASH_PHONE_AUTH_PROVIDER_ID =
  '509d98e3-04ab-49b3-b58a-f6b468550f4d';
export const ANY_AUTH_PROVIDER_ID = '*';
